module.exports = __webpack_public_path__ + "static/media/mario.07b00419.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mario.gif
// module id = 962
// module chunks = 0